import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';

export default function Solution() {
  return (
    <section data-testid="solution-section" className="py-28 px-6 lg:px-10 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Text */}
          <motion.div
            initial={{ opacity: 0, x: -24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          >
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#0A1628]/40 mb-4">
              The Solution
            </p>
            <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-[#0A1628] leading-tight mb-6">
              We save the customers
              <br />
              your team can't
            </h2>
            <p className="text-base md:text-lg text-[#1A1A1A]/65 leading-relaxed">
              Althera Group is a specialist retention service. While your support team handles tickets, we
              focus on one thing — keeping the customers trying to leave. Custom playbooks, fast
              response times, and agents trained specifically in retention conversations.
            </p>
          </motion.div>

          {/* Visual panel */}
          <motion.div
            initial={{ opacity: 0, x: 24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
            className="relative"
          >
            <div className="bg-[#0A1628] rounded-2xl p-10 relative overflow-hidden">
              {/* Decorative blob inside card */}
              <div
                className="absolute -top-12 -right-12 w-48 h-48 rounded-full"
                style={{ background: 'radial-gradient(circle, rgba(0,212,184,0.15) 0%, transparent 70%)' }}
              />
              <div className="relative z-10">
                <div className="w-12 h-12 rounded-xl bg-[#00D4B8]/15 flex items-center justify-center mb-6">
                  <ShieldCheck size={24} strokeWidth={1.5} className="text-[#00D4B8]" />
                </div>
                <p className="text-[#FAFAF7]/50 text-xs font-bold uppercase tracking-[0.18em] mb-3">
                  Our Focus
                </p>
                <h3 className="text-2xl font-semibold text-[#FAFAF7] leading-snug mb-6">
                  One team, one job —<br />retention
                </h3>
                <div className="space-y-3">
                  {['Custom retention playbooks', 'Agents trained in save conversations', '2-hour response guarantee', 'Integrates with your existing helpdesk'].map((item) => (
                    <div key={item} className="flex items-center gap-3">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#00D4B8] flex-shrink-0" />
                      <span className="text-sm text-[#FAFAF7]/70">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
